




















































































import copy from 'copy-text-to-clipboard';
import { Component, Vue } from 'vue-property-decorator';

import { CDN, jsDelivr, unpkg } from '@/constants/cdn';

@Component({
	name: 'Browser'
})
export default class Browser extends Vue {
	jsDelivr: CDN = jsDelivr;
	unpkg: CDN = unpkg;
	tooltipText = 'คลิ๊กเพื่อคัดลอก';

	copyText(text: string) {
		copy(text);

		this.$buefy.toast.open({
			message: 'คัดลอกเรียบร้อย',
			type: 'is-success'
		});
	}
}
